import { Schema as S } from "effect";
export const Schema = S.String.pipe(S.minLength(1), S.maxLength(255), S.brand("@open-revenue/schema/TransactionId"), S.annotations({
    description: "The transaction id from the store"
}));
export const Type = Schema.Type;
export const make = (id)=>S.decodeUnknown(Schema)(id);
export const makeUnsafe = (id)=>id;
